import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Grid, units } from '@ha/dsl';

const useStyles = makeStyles()({
  fullHeight: {
    minHeight: units.vh(100),
  },
  grow: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
});

export const StickyFooter: React.FC = ({ children }) => {
  const { classes } = useStyles();
  return (
    <Grid
      className={classes.fullHeight}
      direction="column"
      wrap="nowrap"
      container
    >
      <div className={classes.grow}>{children}</div>
    </Grid>
  );
};
